import { AuthConsumerRenderProps, Options, withAuthContext } from 'auth/AuthContext';
import axios, { CancelTokenSource } from 'axios';
import DatePicker from 'components/final-form/DatePicker';
import { DropdownOption, mapToDropdownOptionArray } from 'components/final-form/dropdownUtils';
import Select from 'components/final-form/Select';
import FormButtonsRow from 'components/layout/FormButtonsRow';
import FormContainer from 'components/layout/FormContainer';
import FormContent from 'components/layout/FormContent';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import React, { Component } from "react";
import { Field, Form as FinalForm, FormRenderProps } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Grid, Modal } from 'semantic-ui-react';
import { getAllTreatersByMandateId } from 'services/treaterServices';
import { noop } from 'utils/functionUtils';
import { required } from 'utils/validatorUtils';

interface Props extends MessageSourceProps, AuthConsumerRenderProps {
  modalOpen: boolean,
  onCloseModal: () => void
}

interface State {
  treaters: Array<DropdownOption>,
  cancelTokenSource: CancelTokenSource
}

interface OptionValues {
  workDate: string,
  currentTreaterId: number,
}

class OptionsModal extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      treaters: [],
      cancelTokenSource
    };

    this.getTreaters();
  }

  getTreaters = () => {

    const {currentUser} = this.props;
    const {cancelTokenSource} = this.state;

    if (currentUser) {
      getAllTreatersByMandateId(currentUser.userConfig.mandateId, cancelTokenSource).then(response => {
        this.setState({
          treaters: mapToDropdownOptionArray(response, ["firstName", "name"])
        })
      }).catch(noop);
    }
  };

  handleSubmit = async (values: Partial<OptionValues>) => {

    const {setOptions, onCloseModal} = this.props;
    const {treaters} = this.state;

    if (values.workDate && values.currentTreaterId) {

      const treater = treaters.find(treater => treater.value == values.currentTreaterId);

      const options: Options = {
        workDate: values.workDate,
        currentTreater: {
          id: values.currentTreaterId,
          name: treater!.text.toString()
        }
      };

      await setOptions(options);
      onCloseModal();
    }
  };

  render(): React.ReactNode {

    const {modalOpen, onCloseModal, options} = this.props;

    const initialOptions: OptionValues = {
      workDate: options.workDate,
      currentTreaterId: options.currentTreater.id
    };

    return (
        <Modal
            open={modalOpen}
            onClose={onCloseModal}
            style={{width: "400px"}}
            closeOnDimmerClick={false}
        >
          <Modal.Header>Options</Modal.Header>
          <FormModalContentContainer>
            <FinalForm
                onSubmit={this.handleSubmit}
                subscription={{pristine: true, submitting: true}}
                render={this.renderForm}
                initialValues={initialOptions}
            />
          </FormModalContentContainer>
        </Modal>
    );
  }

  renderForm = ({submitting, handleSubmit}: FormRenderProps): React.ReactNode => {

    const {getMessage, onCloseModal} = this.props;
    const {treaters} = this.state;

    return (
        <form onSubmit={handleSubmit}>
          <FormContainer>
            <FormContent>
              <PraxFormGrid>
                <Grid.Row>
                  <Grid.Column width={6} verticalAlign={"middle"}>
                    {getMessage("workDate")}:
                  </Grid.Column>
                  <Grid.Column width={10} verticalAlign={"middle"}>
                    <Field
                        name="workDate"
                        component={DatePicker}
                        validate={required}
                        fluid
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={6} verticalAlign={"middle"}>
                    {getMessage("currentTreater")}:
                  </Grid.Column>
                  <Grid.Column width={10} verticalAlign={"middle"}>
                    <Field
                        name="currentTreaterId"
                        component={Select}
                        options={treaters}
                        validate={required}
                        fluid
                    />
                  </Grid.Column>
                </Grid.Row>
              </PraxFormGrid>
            </FormContent>

            <FormButtonsRow>
              <Button compact type="submit" primary disabled={submitting}>{getMessage("button.save")}</Button>
              <Button compact type="button" disabled={submitting}
                      onClick={onCloseModal}>{getMessage("button.cancel")}</Button>
            </FormButtonsRow>
          </FormContainer>
        </form>
    );
  }
}

export default withMessages(withAuthContext(OptionsModal));
